import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  pageHeader: {},
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px",
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0 0 0 12px",
    marginTop: "4px",
    marginBottom: 0,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginBottom: "20px",
    },
  },
  btnWrapper: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      justifyContent: "flex-start",
    },
  },
  policyBtn: {
    alignItems: "center",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: theme.buttons?.default?.color || colors.grey,
    backgroundColor: theme.buttons?.default?.backgroundColor || colors.white,
    border: theme.buttons?.default?.border || `1px solid ${colors.darkGrey}`,
    "&:hover": {
      backgroundColor: theme.buttons?.default?.hover?.backgroundColor || colors.brightBlue,
    },
  },
  divider: {
    margin: "20px 0px",
    color: colors.lightGrey,
    opacity: 1,
  },
  policyContainer: {
    marginTop: "32px",
    "& h3": {
      color: colors.lightBlack,
      fontWeight: "600",
      fontSize: "18px",
      lineHeight: "28px",
      margin: 0,
    },
    "& p": {
      color: colors.mediumGrey,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      margin: "4px 0px 24px",
    },
  },
  policySettingsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  policyCard: {
    backgroundColor: colors.gray25,
    padding: "24px",
    borderRadius: "12px",
    border: "1px solid " + colors.lightGrey,
    boxShadow:
      "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1)",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "14px",
    },
  },
  policyCardRow: {
    display: "flex",
    gap: "64px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      gap: "30px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column",
      gap: "20px",
    },
  },
  policyRowName: {
    width: "280px",
    flex: "none",
    "& h6": {
      color: colors.grey,
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "20px",
      margin: 0,
    },
    "& p": {
      color: colors.mediumGrey,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      margin: 0,
    },
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      width: "200px",
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "160px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
    },
  },
  policyTextLink: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    margin: 0,
    "& a": {
      textDecoration: "none",
      fontWeight: "500",
      color: theme.text?.themeColor || colors.darkBlue,
    },
  },
  toggleLabel: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    margin: 0,
    "& span": {
      color: colors.grey,
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      marginLeft: "4px",
    },
    "& div": {
      display: "flex",
    },
  },
  policyRowAction: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
  },
  policySelectWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    maxWidth: "320px",
  },
  selectFieldWrapper: {
    width: "100%",
    maxWidth: "320px",
  },
  selectField: {
    width: "auto",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& svg": {
      fill: colors.grey,
    },
  },
  selectAdvancedField: {
    width: "fit-content",
    minWidth: "120px",
    marginTop: "20px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& svg": {
      marginLeft: "-10px",
      fill: colors.grey,
    },
  },
  infoIcon: {
    marginLeft: "8px",
    cursor: "pointer",
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign: "start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none",
    },
    "& a":{
      textDecoration:"none",
      color: theme.text?.themeColor || colors.darkBlue
    },
    "& svg": {
      width: "7px"
    },
  },
  tooltipTitle: {
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "18px",
    marginBottom: "4px",
  },
  tooltipDescription: {
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
  },
  btnContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  cancelBtn: {
    lineHeight: "20px",
    marginRight: "12px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },
  priceInputWrapper: {
    width: "100%",
  },
  errorWrapper: {
    "& span": {
      display: "block",
      marginTop: "6px",
      color: colors.red,
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  priceFieldContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    maxWidth: "320px",
  },
  priceInputGroup: {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.buttons?.default?.border?.replace("1px solid", "") || colors.darkGrey}`,
    borderRadius: "8px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "44px",
    flex: 1,
    backgroundColor: colors.white,
    "&:focus-within": {
      borderColor: theme.colors?.primary || colors.darkBlue,
    },
  },
  currencySymbol: {
    padding: "0 12px",
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
  },
  priceInput: {
    flex: 1,
    border: "none",
    outline: "none",
    fontSize: "16px",
    lineHeight: "24px",
    color: colors.lightBlack,
    padding: "10px 12px 10px 0",
    "&::placeholder": {
      color: colors.mediumGrey,
    },
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  currencySelect: {
    width: "120px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },
  priceInputUnified: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    maxWidth: '320px',
    height: '40px',
    background: theme.field?.backgroundColor || colors.white,
    border: `1px solid ${theme.field?.borderColor || colors.darkGrey}`,
    boxShadow: '0px 1px 2px rgba(10, 13, 18, 0.05)',
    borderRadius: '8px',
  },
  priceInputContent: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0px 8px 12px',
    gap: '8px',
    flexGrow: 1,
    minWidth: 0,
  },
  priceInputDollar: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.choiceGray600,
  },
  priceInputField: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.field?.textColor || colors.lightBlack,
    background: 'transparent',
    MozAppearance: 'textfield',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },
  priceInputIcon: {
    width: '16px',
    height: '16px',
    flexShrink: 0,
    color: colors.choiceIconGray,
  },
  priceInputDropdownSection: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '12px',
    flexShrink: 0,
  },
  priceInputCurrencyText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.choiceGray600,
  },
  advancePurchaseInfoIcon: {
    width: '16px',
    height: '16px',
    color: colors.choiceIconGray,
    marginLeft: '20px',
  },
  multiSelectValueLabel: {
    position: 'absolute',
    left: '12px',
    fontSize: '14px',
    fontWeight: '600',
    color: colors.grey,
    pointerEvents: 'none',
  },
  specificPolicyHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  specificPolicyBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    "& h6": {
      color: colors.lightBlack,
      fontWeight: "600",
      fontSize: "16px",
      lineHeight: "24px",
      margin: "16px 0px 4px",
    },
    "& p": {
      color: colors.mediumGrey,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      margin: 0,
    },
  },
  specificPolicyWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  specificPolicyContainer: {
    display: "flex",
    justifyContent: "space-between",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column",
    },
  },
  specificPolicyInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      alignItems: "center",
      marginTop: "10px",
      gap: "24px",
    },
    "& div": {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      textAlign: "center",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        flexDirection: "column",
        gap: "10px",
      },
    },
    "& h6": {
      color: colors.lightBlack,
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      margin: 0,
    },
    "& span": {
      color: colors.mediumGrey,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      margin: 0,
    },
    "& svg": {
      margin: "0px 4px",
      flexShrink: 0,
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        transform: "rotate(90deg)",
        margin: "2px",
      },
    },
  },
  editSpecificBtn: {
    color: colors.mediumGrey,
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "20px 0px -8px 10px",
      width: "fit-content",
    },
  },
  policyFooter: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    margin: "32px 0px 48px",
  },
  brandLabel:{
    display: "inline-flex",
    gap: "8px"
  },
  brandName:{
     fontSize: "16px",
    fontWeight: "500",
    lineHeight: "24px",
    color: theme.field?.textColor || colors.lightBlack
  },
  toggle: {
    display: "flex",
    alignItems: "center",
    "& span": {
      marginLeft: "12px",
    },
    "& .react-toggle--checked": {
      "& .react-toggle-thumb": {
        left: "22px",
      },
      "& .react-toggle-track": {
        backgroundColor: theme.toggle.checked.backgroundColor,
        "&:hover": {
          backgroundColor: theme.toggle.checked.hover.backgroundColor,
        },
      },
    },
    "& .react-toggle": {
      "& .react-toggle-track": {
        width: "44px",
        height: "24px",
        backgroundColor: theme.toggle.unchecked.backgroundColor,
        "&:hover": {
          backgroundColor: theme.toggle.unchecked.hover.backgroundColor,
        },
      },
    },
    "& .react-toggle-thumb": {
      backgroundColor: theme.toggle.thumbColor,
      left: "2px",
      width: "20px",
      height: "20px",
      top: "2px",
      border: "none",
      boxShadow: "none !important",
      filter:
        "drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06)) drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.10))",
    },
    "& .react-toggle--focus": {
      "& .react-toggle-thumb": {
        boxShadow: `0px 0px 2px 3px ${theme.colors.primary} !important`
      },
    },
  },
}));

export default styles;

export const selectField = (theme) => ({
  control: (base) => ({
    ...base,
    borderColor: theme.buttons?.default?.border?.replace("1px solid", "") || colors.darkGrey,
    borderRadius: "8px",
    "&:hover": {
      borderColor: theme.buttons?.default?.border?.replace("1px solid", "") || colors.darkGrey,
    },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "14px",
    img: {
      display: state.isSelected ? "inline" : "none",
      marginLeft: "6px",
    },
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 8px",
    backgroundColor: state.isSelected
      ? (theme.modal?.selectedOption?.backgroundColor || colors.brightBlue)
      : colors.white,
    borderRadius: "6px",
    color: state.isSelected
      ? (theme.modal?.selectedOption?.text?.color || colors.lightBlack)
      : colors.lightBlack,
    "&:hover": {
      backgroundColor: theme.modal?.optionHover?.backgroundColor || colors.brightBlue,
    },
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "600",
    color: theme.toggle?.color || colors.grey,
  }),
});

export const lengthSelect = {
  menu: (base) => ({
    ...base,
    borderRadius: "8px",
    marginTop: "4px",
    boxShadow: `0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08);`,
    border: `1px solid ${colors.lightGrey}`,
    width: "80px",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "14px",
    img: {
      display: state.isSelected ? "inline" : "none",
      marginLeft: "6px",
    },
    display: "flex",
    padding: "10px 8px",
    backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
    borderRadius: "6px",
    color: colors.lightBlack,
    "&:hover": {
      backgroundColor: colors.brightBlue,
    },
  }),
  control: (base, state) => ({
    ...base,
    backgroundColor: "inherit",
    height: "40px",
    width: "70px",
    borderRadius: 0,
    borderColor: colors.darkGrey,
    "&:hover": {
      borderColor: colors.darkGrey,
    },
    boxShadow: null,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
  input: (base) => ({
    ...base,
    minWidth: "40px",
    margin: "0px",
    padding: "0px",
  }),
  singleValue: (base, state) => ({
    ...base,
    marginLeft: "8px",
    marginRight: "0px",
    padding: "0px",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "600",
    color: state.isDisabled ? colors.darkGrey : colors.grey,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0",
    color: colors.inactiveGrey,
    "&:hover": {
      color: colors.inactiveGrey,
    },
  }),
  indicatorsContainer: (base, state) => ({
    ...base,
    width: "20px",
    marginRight: "16px",
    "& svg": {
      fill: state.isDisabled ? colors.darkGrey : colors.grey,
    },
  }),
};

export const currencyDropdownStyles = (selectFieldStyles, theme) => ({
  ...selectFieldStyles,
  control: (base) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    background: 'transparent',
    minHeight: 'auto',
    cursor: 'pointer',
    flexWrap: 'nowrap',
    '&:hover': { border: 'none' },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    flex: '0 0 auto',
    overflow: 'visible',
  }),
  singleValue: (base) => ({
    ...base,
    position: 'static',
    transform: 'none',
    maxWidth: 'none',
    margin: 0,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: colors.choiceGray600,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (base) => ({
    ...base,
    width: 'auto',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0 0 0 4px',
    paddingRight: 0,
    color: colors.choiceIconGray,
  }),
  menu: (base) => ({
    ...base,
    width: '100px',
    right: 0,
  }),
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    'img': {
      display: state.isSelected ? 'inline' : 'none',
    },
    padding: "8px 10px",
    backgroundColor: state.isSelected ? colors.brightBlue : (state.isFocused ? colors.brightBlue : colors.white),
    borderRadius: "6px",
    color: theme?.field?.textColor || colors.lightBlack,
    "&:hover": {
      backgroundColor: colors.brightBlue,
    },
     ":active": {
      backgroundColor: colors.brightBlue,
    },
  }),
});